var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 113,
  height: 89,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#25221E",
  strokeLinecap: "round",
  strokeOpacity: 0.49,
  strokeWidth: 2,
  d: "M106.181 79.468c4.372-15.393 6.458-30.629 0-45.543-17.52-40.642-66.042-42.899-75.95-10.966-4.036 13.04 9.244 20.211 14.811 10.309 3.474-6.26-2.298-14.275-12.462-15.208C19.803 16.884 8.5 18.5 1 21.755"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#25221E",
  fillOpacity: 0.49,
  d: "M102.174 75.797a.83.83 0 0 1 .501.428q.128.3.092.867-.01 1.364.297 2.816.286 1.444.825 2.698.385.927.87 1.569a12 12 0 0 0 1.726-.9 18 18 0 0 0 2.02-1.477 22 22 0 0 0 1.703-1.564q.413-.39.692-.524a.66.66 0 0 1 .52-.029q.393.136.596.486.176.362.032.776-.064.186-.171.358a5 5 0 0 1-.484.527 17 17 0 0 1-1.212 1.086q-.721.607-1.56 1.22a30 30 0 0 1-1.711 1.121q-.873.508-1.659.838-.411.181-.619.179a1.5 1.5 0 0 1-.435-.082 1.6 1.6 0 0 1-.317-.156q-.179-.086-.425-.38-.547-.56-1.005-1.508a13 13 0 0 1-.854-2.082 17 17 0 0 1-.587-2.314 14 14 0 0 1-.249-2.22q.014-.435.036-.636.024-.2.11-.449.137-.393.464-.603.328-.21.804-.046"
})));
export default SvgDesktopArrow;